<template>
  <div class="marker-action">
    <list-action-form
      ref="form"
      :ids="ids"
      :labels="labels"
      :route="route"
      :method="method"
      @submitted="toggle"
    >
      <input type="hidden" name="fund" :value="fund" />
      <input type="hidden" name="amount" :value="inputValue" />
      <portal :to="name">
        <modal
            v-model="showModal"
            :title="labels.button"
            :header="true"
            :confirm-button-label="labels.ok"
            :confirm-disabled="disableConfirm"
            :close-button-label="labels.cancel"
            :header-close-button="true"
            @closed="modalClosed"
            @confirmed="submit"
        >
          <div class="row">
          <div class="col-md-6">
            <div class="form-group">
            <select-field
                :items="funds"
                :value="fund"
                placeholder="Select fund"
                :empty-option="true"
                @selected="onFundSelected"
                aria-label="fund"
            >
            </select-field>
            </div>
          </div>
            <div class="col-md-6">
              <div :class="['form-group', {error : error}]">
              <currency-input
                  id="fundAllocationAmount"
                  v-model="inputValue"
                  class="form-control"
                  :currency="currency"
                  :locale="currentLocale"
                  :distraction-free="false"
                  :allow-negative="false"
                  :placeholder="placeHolder"
                  :disabled="!fund"
                  @focusout="onFocusOut"
                  @input="validateInput"
                  aria-label="amount"
                  
              ></currency-input>
                <span class="help-block error" v-if="error">{{ validationMessage }}</span>
            </div>
          </div>
          </div>
        </modal>
        
      </portal>
    </list-action-form>
  </div>
</template>

<script>
import ListAction from './ListAction.vue';
import { SelectField, Modal } from 'vue-bootstrap';
import { CurrencyInput } from 'vue-currency-input';
import langMixin from '../Translations/mixins/lang-mixin' 

/**
 * The FundAllocator component.
 */
export default {
  components: {
    SelectField,
    Modal,
    CurrencyInput
  },
  mixins: [langMixin],
  extends: ListAction,
  props: {
    name: {
      type: String,
      required: true,
      validator: value => value.startsWith('fund-allocator')
    },
    funds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      fund: null,
      inputValue: null,
      currency: null,
      selectedFund: null,
      available: 0,
      error: false
    };
  },
  computed: {
    currentLocale() {
      this.lang.locale.replace('_', '-')
    },
    validationMessage() {
      if (this.fund && this.max === 0) {
        return ''
      }
      return this.lang.get('validation.max.numeric', {'attribute' : 'amount', 'max' : this.formatCurrency(this.max)});
    },
    placeHolder() {
      if (this.currency) {
        return this.formatCurrency(0, 0).replace('0', '');
      }
      return this.lang.get('funding.form.amount.placeholder');
    },
    max() {
      return this.available / this.ids.length;
    },
    disableConfirm()
    {
      return !this.fund || this.error || this.inputValue === null || this.inputValue === ''
    }
  },
  methods: {
    formatCurrency(amount, fractionDigits = 2)
    {
      if (this.currency) {
        return Number(amount).toLocaleString(this.currentLocale, {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: fractionDigits
        });
      }
      return 0;
    },
    toggle() {
      this.showModal = true;
      this.$emit('reveal', this.name);
    },
    onFundSelected(name, value) {
      this.fund = value;
      const selectedFund = this.funds.find((fund) => fund.id === this.fund)
      this.available = selectedFund ? selectedFund.available : 0;
      this.currency = selectedFund ? selectedFund.currency.code : null;
    },
    onFocusOut() {
      this.inputValue = this.calculateValue(this.inputValue);
    },
    calculateValue(value) {
      return value !== '' && value !== null ? Number(value) : null;
    },
    modalClosed() {
      this.showModal = false;
      this.$nextTick(function () {
        this.$emit('reveal', null);
      });
    },
    validateInput(value) {
      this.error = value > this.max;
    }
  }
};
</script>
